import React, { FC } from 'react';
import { SearchFieldProps } from './SearchField.types';
import { StyledSearchField } from './SearchField.styles';
import { SearchFieldCategories } from './SearchFieldCategories';
import { StaticHotelSearchField } from './StaticHotelSearchField/StaticHotelSearchField';
import { useStaticDataContext } from '../../modules/context';
export const SearchField: FC<SearchFieldProps> = ({
  onCancel,
  onChange: changeMobileState,
  isModalOpen,
  isDesktopView,
  mobileModalHeading,
  mobilePlaceHolderText,
  hideClearCta = false,
  isMeetingDestField,
  isMobileForm,
  blacklist,
}) => {
  // Authoring source
  const { staticDestinations, enableStaticDestinations } = useStaticDataContext();

  return (
    <StyledSearchField data-component-name="m-shop-SearchField" data-testid="shop-SearchField">
      {enableStaticDestinations ? (
        <StaticHotelSearchField
          metros={staticDestinations}
          isDesktopView={isDesktopView}
          isModalOpen={isModalOpen}
          onCancel={onCancel}
          changeMobileState={changeMobileState}
          mobileModalHeading={mobileModalHeading}
          mobilePlaceHolderText={mobilePlaceHolderText}
          hideClearCta={hideClearCta}
          isMobileForm={isMobileForm}
          showMarshaCode={false}
          highlightMatches={false}
          hotelIndentPx={16}
          headerTransform="none"
        />
      ) : (
        <SearchFieldCategories
          isDesktopView={isDesktopView}
          isModalOpen={isModalOpen}
          changeMobileState={changeMobileState}
          onCancel={onCancel}
          mobileModalHeading={mobileModalHeading}
          mobilePlaceHolderText={mobilePlaceHolderText}
          hideClearCta={hideClearCta}
          isMeetingDestField={isMeetingDestField}
          isMobileForm={isMobileForm}
          blacklist={blacklist}
        />
      )}
    </StyledSearchField>
  );
};
